import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import {
	CreateRestaurantContext,
	ICreateRestaurantContext,
} from '../../../../createRestaurantState/createRestaurantContext';
import BtnBlock from './components/BtnBlock';
import AddressField from './components/AddressField';
import NameField from './components/NameField';
import EmailField from './components/EmailField';
import CodeField from './components/CodeField';
import PriceTypeField from './components/PriceTypeField';
import IsUsedCustomerPriceTypeCheckbox from './components/IsUsedCustomerPriceTypeCheckbox';
import DefaultLanguageSelect from './components/DefaultLanguageSelect';
import ClientTypeSelect from './components/ClientTypeSelect';
import CountrySelect from './components/CountrySelect';
import CitySelect from './components/CitySelect';
import CustomerSelect from './components/CustomerSelect';
import PosSystemSelect from './components/PosSystemSelect';
import CurrencySelect from './components/CurrencySelect';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCountry,
		setFetchedCountries,
		setIDCity,
		setFetchedCities,
		setIDCustomer,
		setFetchedCustomers,
		setClientType,
		changeName,
		setCurrencySymbol,
		setFetchedCurrencies,
		changeAddress,
		changeEmail,
		changeCode,
		changePriceType,
		toggleIsUsedCustomerPriceType,
		setIDPosSystem,
		setIDDefaultLanguage,
		setFetchedLanguages,
		IDSelectedCountry,
		IDSelectedCity,
		IDSelectedCustomer,
		clientType,
		name,
		selectedCurrencySymbol,
		address,
		email,
		code,
		priceType,
		isUsedCustomerPriceType,
		IDPosSystem,
		IDSelectedDefaultLanguage,
	} = useContext<ICreateRestaurantContext>(CreateRestaurantContext);
	const [form] = Form.useForm();
	const rowWithFlex1Classes = classNames(style.row, style.flex1);

	useEffect(() => {
		form.setFieldsValue({ IDSelectedCountry });
		form.setFieldsValue({ IDSelectedCity });
		form.setFieldsValue({ IDSelectedCustomer });
		form.setFieldsValue({ clientType });
		form.setFieldsValue({ name });
		form.setFieldsValue({ selectedCurrencySymbol });
		form.setFieldsValue({ address });
		form.setFieldsValue({ email });
		form.setFieldsValue({ code });
		form.setFieldsValue({ priceType });
		form.setFieldsValue({ isUsedCustomerPriceType });
		form.setFieldsValue({ IDPosSystem });
		form.setFieldsValue({ IDSelectedDefaultLanguage });
	}, [
		IDSelectedCountry,
		IDSelectedCity,
		IDSelectedCustomer,
		clientType,
		name,
		selectedCurrencySymbol,
		address,
		email,
		code,
		priceType,
		isUsedCustomerPriceType,
		IDPosSystem,
		IDSelectedDefaultLanguage,
	]);

	const submit = async () => {
		setDataForSubmit({
			name,
			address,
			customerId: IDSelectedCustomer || '',
			cityId: IDSelectedCity || '',
			countryId: IDSelectedCountry || '',
			restaurantType: clientType || 1,
			defaultLanguageId: IDSelectedDefaultLanguage || '',
			isoCurrencySymbol: selectedCurrencySymbol || '',
			email,
			code: code ? code.toUpperCase() : null,
			posSystemId: IDPosSystem,
			priceType,
			isUsedCustomerPriceType,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<CountrySelect setIDCountry={setIDCountry} setFetchedCountries={setFetchedCountries} />
						<CitySelect
							IDSelectedCountry={IDSelectedCountry}
							setIDCity={setIDCity}
							setFetchedCities={setFetchedCities}
						/>
					</div>
					<div className={style.row}>
						<CustomerSelect setIDCustomer={setIDCustomer} setFetchedCustomers={setFetchedCustomers} />
						<ClientTypeSelect setClientType={setClientType} />
					</div>
					<div className={style.row}>
						<NameField changeName={changeName} />
						<CurrencySelect
							setCurrencySymbol={setCurrencySymbol}
							setFetchedCurrencies={setFetchedCurrencies}
						/>
					</div>
					<AddressField changeAddress={changeAddress} />
					<EmailField changeEmail={changeEmail} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantCodeHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={rowWithFlex1Classes}>
						<CodeField changeCode={changeCode} />
						<div />
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="priceTypeHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<PriceTypeField
							changePriceType={changePriceType}
							isUsedCustomerPriceType={isUsedCustomerPriceType}
						/>
						<IsUsedCustomerPriceTypeCheckbox
							toggleIsUsedCustomerPriceType={toggleIsUsedCustomerPriceType}
							isUsedCustomerPriceType={isUsedCustomerPriceType}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="posHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<PosSystemSelect setIDPosSystem={setIDPosSystem} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="languagesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<DefaultLanguageSelect
						IDSelectedCustomer={IDSelectedCustomer}
						setIDDefaultLanguage={setIDDefaultLanguage}
						setFetchedLanguages={setFetchedLanguages}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
